import Modal from "bootstrap/js/dist/modal";
import { gsap } from "../layout"

// custom library
import Choices from 'choices.js'

function choicesJs() {
    const inquiry = document.querySelector('#inquiry')
    const destination = document.querySelector('#destination')

    if (inquiry) {
        const choicesInq = new Choices(inquiry, {
            searchEnabled: false,
            itemSelectText: ' ',
            allowHTML: true,
            shouldSort: false,
        });
    }

    if (destination) {
        const choicesDes = new Choices(destination, {
            searchEnabled: false,
            itemSelectText: ' ',
            allowHTML: true,
            shouldSort: false,
        });
    }
}

function disableSubmitForm() {
    const submitBtn = document.querySelector('.wpcf7-submit')

    submitBtn.addEventListener('click', () => {
        submitBtn.classList.add('disabled')
    })
}

function showSuccessModal() {
    const modal = new Modal('#successModal')
    modal.show()
}

document.addEventListener('DOMContentLoaded', () => {
    choicesJs()
    disableSubmitForm()
})

document.addEventListener( 'wpcf7mailsent', function( event ) {
    showSuccessModal()
}, false );

document.addEventListener( 'wpcf7submit', function( event ) {
    const submitBtn = document.querySelector('.wpcf7-submit')
    submitBtn.classList.remove('disabled')
}, false );